function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 4.5C2.55109 4.5 2.36032 4.57902 2.21967 4.71967C2.07902 4.86032 2 5.05109 2 5.25C2 5.44891 2.07902 5.63968 2.21967 5.78033C2.36032 5.92098 2.55109 6 2.75 6H17.25C17.4489 6 17.6397 5.92098 17.7803 5.78033C17.921 5.63968 18 5.44891 18 5.25C18 5.05109 17.921 4.86032 17.7803 4.71967C17.6397 4.57902 17.4489 4.5 17.25 4.5H2.75Z",
  fill: "#001C28"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 7.5C2.55109 7.5 2.36032 7.57902 2.21967 7.71967C2.07902 7.86032 2 8.05109 2 8.25C2 8.44891 2.07902 8.63968 2.21967 8.78033C2.36032 8.92098 2.55109 9 2.75 9H17.25C17.4489 9 17.6397 8.92098 17.7803 8.78033C17.921 8.63968 18 8.44891 18 8.25C18 8.05109 17.921 7.86032 17.7803 7.71967C17.6397 7.57902 17.4489 7.5 17.25 7.5H2.75Z",
  fill: "#001C28"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 11.25C2 11.0511 2.07902 10.8603 2.21967 10.7197C2.36032 10.579 2.55109 10.5 2.75 10.5H17.25C17.4489 10.5 17.6397 10.579 17.7803 10.7197C17.921 10.8603 18 11.0511 18 11.25C18 11.4489 17.921 11.6397 17.7803 11.7803C17.6397 11.921 17.4489 12 17.25 12H2.75C2.55109 12 2.36032 11.921 2.21967 11.7803C2.07902 11.6397 2 11.4489 2 11.25Z",
  fill: "#001C28"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 13.5C2.55109 13.5 2.36032 13.579 2.21967 13.7197C2.07902 13.8603 2 14.0511 2 14.25C2 14.4489 2.07902 14.6397 2.21967 14.7803C2.36032 14.921 2.55109 15 2.75 15H12.25C12.4489 15 12.6397 14.921 12.7803 14.7803C12.921 14.6397 13 14.4489 13 14.25C13 14.0511 12.921 13.8603 12.7803 13.7197C12.6397 13.579 12.4489 13.5 12.25 13.5H2.75Z",
  fill: "#001C28"
});

function SvgItemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemIcon);
export default __webpack_public_path__ + "static/media/item-icon.3da037a7.svg";
export { ForwardRef as ReactComponent };